import { TreeState } from '@/models/generics'
import _ from 'lodash'
import { computed, nextTick, reactive, watch } from 'vue'

export default function useTreeNode (props, { emit }) {
  const state = reactive<TreeState>({
    id: Date.now().toString(16),
    data: props.modelValue,
    keyIndex: Object.keys(props.modelValue).map((key, index) => ({ key, index })),
    suggestions: props.suggestions || []
  })

  watch(() => Object.keys(props.modelValue), value => {
    state.data = props.modelValue

    Object.keys(state.data).forEach(key => {
      if (!state.keyIndex.find(index => index.key === key)) state.keyIndex.push({ key, index: state.keyIndex.length })
    })
  })

  watch(() => state.data, value => {
    emit('update:modelValue', value)
  }, {deep: true})

  function addNode (object, value = 'enter a value') {
    const key = `field-${Object.keys(state.data).length}`
    _.set(object, key, value)

    const index = state.keyIndex.findIndex(keyIndex => keyIndex.key === key)
    if (index < 0) state.keyIndex.push({ key, index: state.keyIndex.length })

    emit('node:add', { key, value })
    update()
  }

  function removeNode (key, object, event) {
    const index = state.keyIndex.findIndex(keyIndex => keyIndex.key === key)
    state.keyIndex.splice(index, 1)
    delete object[key]
    emit('node:remove', { key, object, index })
  }

  function update () {
    emit('update:modelValue', state.data)
  }

  function setNodeKey (key, object, event, elementId) {
    try {
      const newKey = event.target.value
      if (key !== newKey) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        Object.defineProperty(object, newKey, Object.getOwnPropertyDescriptor(object, key))
        delete object[key]

        const keyIndex = state.keyIndex.findIndex(f => f.key === key)
        if (keyIndex >= 0) state.keyIndex[keyIndex].key = newKey
        update()

        void nextTick(() => {
          const el = document.getElementById(elementId)
          el?.focus()
        })
      }
    } catch (e) {
      console.error('setNodeKey error', e)
    }
  }

  const dbSetNodeKey = _.debounce(setNodeKey, 400, { leading: false, trailing: true })

  return {
    state,
    addNode,
    removeNode,
    update,
    setNodeKey,
    dbSetNodeKey
  }
}
